import { SvgProps } from "./Form";

export const RecycleIcon = (props: SvgProps) => (
  <svg
    {...props}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_6675_2957)">
      <path
        d="M13.8355 13.326C13.6025 13.748 13.1755 14 12.6935 14H11.5V13H12.6935C12.856 13 12.934 12.8895 12.9605 12.8425C12.9865 12.795 13.038 12.67 12.952 12.533L12.3785 11.62L13.225 11.088L13.7985 12.001C14.055 12.409 14.069 12.9045 13.8355 13.326ZM12.4275 9.8165L11.8365 8.876C11.596 8.4925 11.1835 8.2645 10.7315 8.2645H10.726C10.2715 8.2665 9.8585 8.4985 9.62 8.885L9.051 9.809L9.9025 10.3335L10.4715 9.4095C10.552 9.279 10.6795 9.2645 10.7305 9.2645C10.794 9.2685 10.9085 9.2775 10.99 9.4075L11.581 10.3485L12.4275 9.8165ZM6.794 13.819C6.8295 13.8825 6.8705 13.9405 6.911 13.9995H5.164C4.3985 13.9995 3.7575 13.426 3.673 12.665L2.822 5H2V4H5V3C5 2.4485 5.4485 2 6 2H9C9.5515 2 10 2.4485 10 3V4H13V5H12.159L11.8735 7.5685C11.58 7.4015 11.249 7.3025 10.9 7.2765L11.153 5.0005H3.828L4.6675 12.5555C4.696 12.809 4.9095 13.0005 5.1645 13.0005H6.521C6.5595 13.2815 6.6485 13.559 6.794 13.82V13.819ZM6 3.9995H9V2.9995H6V3.9995ZM8.54 12.8435C8.5135 12.7965 8.4615 12.672 8.5465 12.5345L9.116 11.6105L8.265 11.086L7.6955 12.01C7.444 12.4185 7.4335 12.9125 7.6675 13.3315C7.9015 13.75 8.3275 14 8.807 14H10.0005V13H8.807C8.6455 13 8.567 12.8905 8.5405 12.844L8.54 12.8435Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_6675_2957">
        <rect width="12" height="12" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>
);
